import en from './en';

export const timerTranslations: NamespaceTranslations<keyof typeof en> = {
  en,
};
